import update from 'immutability-helper';
import React, { createContext, useReducer, useContext } from 'react';

import useProduct from '../../useProduct';

const VariantsContext = createContext();

function variantsReducer(state, action) {
  switch (action.type) {
    case 'add':
      if (state && state.length > 0) {
        const newIndex = action.index || state.length;

        return update(state, {
          // set all other variants to isEditing false
          $apply: currentState => currentState.map(v => ({ ...v, isEditing: false })),
          // add new variant at the specified index
          $splice: [[newIndex, 0, ...action.values]],
        });
      } else {
        return action.values;
      }
    case 'set': {
      return update(state, {
        $set: action.values,
      });
    }
    case 'update': {
      if (action.variant._id) {
        const index = state.findIndex(variant => variant._id === action.variant._id);

        return update(state, {
          [index]: {
            $set: action.values,
          },
        });
      } else {
        const index = state.findIndex(variant => variant.key === action.variant.key);

        return update(state, {
          [index]: {
            $set: action.values,
          },
        });
      }
    }
    case 'delete': {
      if (action.variant._id) {
        return state.filter(f => f._id !== action.variant._id);
      } else {
        return state.filter(f => f.key !== action.variant.key);
      }
    }
    default:
      return state;
  }
}

export const VariantsProvider = ({ children }) => {
  const { product } = useProduct();

  const [state, dispatch] = useReducer(variantsReducer, product?.variants || []);

  return (
    <VariantsContext.Provider value={{ state, dispatch }}>{children}</VariantsContext.Provider>
  );
};

export const useVariants = () => useContext(VariantsContext);
